import React from "react";
import { useTranslation } from "react-i18next";
function Network() {
  const { t, i18n } = useTranslation()
  return (
    <>
      <section className="p-30 bgGradient">
        <div className="container">
          <div className="networkItem">
            <div className="fisherman-content mb-4">
              <h3>{t('Our Network')} </h3>
            </div>
            <ul className="namedd">
              <li>
                <div className="networkNumber">
                  <h2>97%</h2>
                  <p>{t('Product Efficiency')}</p>
                </div>
              </li>
              <li>
              <div className="networkNumber">
                  <h2>100%</h2>
                  <p>{t('Product Packing  ')}</p>
                </div>
              </li>
              <li>
              <div className="networkNumber">
                  <h2>98%</h2>
                  <p>
                  {t('Customer Satisfaction')}
                  </p>
                </div>
              </li>
              <li>
              <div className="networkNumber">
                  <h2>98%</h2>
                  <p>
                  {t('Product Quality')}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default Network;
